import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faClipboardList,
    faHome,
    faLayerGroup,
    faSearch,
    faShoppingCart,
} from '@fortawesome/free-solid-svg-icons';
import './PublicNavigation.css';

const navLinkClassName = ({ isActive }) => (
    `public-navigation__item${isActive ? ' public-navigation__item--active' : ''}`
);

export default function PublicNavigation({
    cartButtonRef,
    cartCount = 0,
    onOpenCart,
    onOpenSearch,
    searchButtonRef,
}) {
    return (
        <nav className="public-navigation" aria-label="Navegación pública">
            <NavLink to="/" end className={navLinkClassName}>
                <FontAwesomeIcon icon={faHome} aria-hidden="true" />
                <span>Inicio</span>
            </NavLink>

            <NavLink to="/categorias" className={navLinkClassName}>
                <FontAwesomeIcon icon={faLayerGroup} aria-hidden="true" />
                <span>Categorías</span>
            </NavLink>

            <button
                ref={searchButtonRef}
                type="button"
                className="public-navigation__item"
                onClick={onOpenSearch}
                aria-haspopup="dialog"
            >
                <FontAwesomeIcon icon={faSearch} aria-hidden="true" />
                <span>Buscar</span>
            </button>

            <button
                ref={cartButtonRef}
                type="button"
                className="public-navigation__item public-navigation__cart"
                onClick={onOpenCart}
                aria-haspopup="dialog"
                aria-label={`Carrito, ${cartCount} ${cartCount === 1 ? 'producto' : 'productos'}`}
            >
                <FontAwesomeIcon icon={faShoppingCart} aria-hidden="true" />
                {cartCount > 0 && (
                    <span className="public-navigation__count" aria-hidden="true">
                        {cartCount}
                    </span>
                )}
                <span>Carrito</span>
            </button>

            <NavLink to="/mi-pedido" className={navLinkClassName}>
                <FontAwesomeIcon icon={faClipboardList} aria-hidden="true" />
                <span>Mi pedido</span>
            </NavLink>
        </nav>
    );
}
